import { DeviceReadingUnitMeasureOption } from '@moduleAForm';
import { DqpReading } from '@types';

import { Mapper } from './Mapper';

interface ReadingFormValues {
	readingValue: string;
	readingUnit: DeviceReadingUnitMeasureOption;
}

export class ReadingMapper extends Mapper<ReadingFormValues, DqpReading, DqpReading> {
	mapToForm(data: DqpReading): ReadingFormValues {
		return {
			readingValue: data?.readingValue ?? '',
			readingUnit: data?.unitOfMeasure as unknown as DeviceReadingUnitMeasureOption, // prettier-ignore
		};
	}

	mapFormToPayload(formValues: Partial<ReadingFormValues>): Partial<DqpReading> {
		return {
			readingValue: formValues.readingValue?.length ? formValues.readingValue : undefined,
			unitOfMeasure: formValues.readingUnit,
		};
	}

	mapModelToPayload(data: DqpReading): DqpReading {
		return data;
	}
}
